import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectCidade } from '../../app/slices/cidadesSlice';
import { fecharModalAjuda, fecharModalServico } from '../../app/slices/modalSlice';
import { ContainerJanela, Divisor, Linha } from '../../styles/base';
import { replaceTags } from '../../util/stringFactory';
import Botao from '../Botao/Botao';
import { Ajuda, JanelaAjuda, TituloAjuda } from './ModalServicoEstilo';

const ModalServico = () => {
  const dispatch = useDispatch();
  const dadosCidade = useSelector(selectCidade);

  return (
    <ContainerJanela>
      <JanelaAjuda className="controle-fundo controle-modal">
        <Linha style={{ justifyContent: 'flex-end' }}>
          <Botao
            fechar
            onClick={() => dispatch(fecharModalServico())}
          />
        </Linha>

        <TituloAjuda>Serviços - Ajuda</TituloAjuda>

        <Divisor />

        <Ajuda className="controle-fundo">
          A central de serviços tem por objetivo viabilizar o acesso de informações da instituição através do aplicativo eOuve.
        </Ajuda>

      </JanelaAjuda>
    </ContainerJanela>
  );
};

export default ModalServico;
